// extracted by mini-css-extract-plugin
export var UnsupportedBrowserModal = "UnsupportedBrowserModal-module--UnsupportedBrowserModal--8YSZM";
export var UnsupportedBrowserModalInner = "UnsupportedBrowserModal-module--UnsupportedBrowserModalInner--1lTXu";